import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { uploadImage, uploadImageWithoutSize } from "../../shared/api/user";
import { addProduct } from "../../shared/api/user";
import { useNavigate } from "react-router-dom";
import { inputLabelClasses } from "@mui/material/InputLabel";

const theme = createTheme();
export default function SignUp() {
  const [File, setFile] = React.useState();
  const [uploadedImage, setUploadedImage] = useState(null);
  const navigate = useNavigate();
  const style = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#CB2704",
      },
    },
  };

  const handleFile = async (event) => {
    console.log(event);
    setFile(event.target.files[0]);
    console.log(File);
    const reader = new FileReader();
    reader.onload = () => {
      setUploadedImage(reader.result);
    };
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

//   const init = async () => {
    // let user = await getMe();
//   };
//   useEffect(() => {
//     init();
//   }, []);

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ mt: 2, mb: 2, fontWeight: "600" }}
            component="h1"
            variant="h5"
          >
            Add Employee Data
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Formik
                initialValues={{
                  name: "",
                  email: "",
                  phoneNumber: "",
                  category: "",
                  picture: "",
                  cnic: "",
                  about: "",
                  isActive: "",
                  address: "",
                  salary: "",
                  bankName: "",
                  accountNumber: "",
                  branchName: "",
                  joiningDate: "",
                  cnicFront: "",
                  cnicBack: "",
                }}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(async () => {
                    if (File) {
                      const formData = new FormData();
                      formData.append("file", File);
                      let res = await uploadImageWithoutSize(formData);
                      values.picture = res.data.data.url;
                    }

                    values.price = parseFloat(values.price);
                    console.log(values);
                    let prod = await addProduct(values);
                    console.log(prod);
                    setSubmitting(false);
                    navigate("/employees");
                    // window.location.reload();
                  }, 400);
                }}
              >
                {({ handleSubmit, handleChange, isSubmitting, values }) => (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    <Grid mb={3} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="name"
                        label="Product Name"
                        name="name"
                        autoComplete="text"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid mb={3} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="description"
                        label="Description"
                        name="description"
                        autoComplete="text"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid mb={2} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704",
                            },
                          },
                        }}
                        fullWidth
                        id="price"
                        label="Price"
                        name="price"
                        type="text"
                        autoComplete="text"
                        onChange={handleChange}
                      />
                    </Grid>

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      {uploadedImage && (
                        <img
                          src={uploadedImage}
                          alt="Uploaded"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "200px",
                            borderRadius: "10px",
                          }}
                        />
                      )}
                    </div>

                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      sx={{
                        mt: 3,
                        mb: 1,
                      }}
                    >
                      Upload Image
                      <input type="file" onChange={handleFile} hidden />
                    </Button>

                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      fullWidth
                      variant="contained"
                      sx={{
                        mt: 2,
                        mb: 2,
                      }}
                    >
                      Submit
                    </Button>
                  </form>
                )}
              </Formik>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
